import { OnboardingStateType } from "@intelligems/ig-types";

export type OnboardingReducerAction =
  | {
      type: "buttonClick";
      payload: {
        direction: "next" | "back";
      };
    }
  | {
      type: "selectPlan";
      value: string;
    }
  | {
      type: "gotoStep";
      value: number;
    };

export function OnboardingReducer(
  draft: OnboardingStateType,
  action: OnboardingReducerAction
) {
  switch (action.type) {
    case "gotoStep":
      draft.activeStep = action.value;
      draft.progress = 20 * (action.value + 1);
      return draft;
    case "buttonClick":
      if (action.payload.direction === "next") {
        draft.activeStep = draft.activeStep + 1;
        draft.progress = 20 * (draft.activeStep + 1);
      } else {
        draft.activeStep = draft.activeStep - 1;
        draft.progress = 20 * (draft.activeStep + 1);
      }
      return draft;
    case "selectPlan":
      draft.selectedPlan = action.value;
      return draft;
    default:
      return draft;
  }
}
